import { createSlice } from '@reduxjs/toolkit';
import { getCookie, decodeJwt } from '../../utilities';

const buildAuthState = () => {
  const token = getCookie('_tk');
  const decoded = token ? decodeJwt(token) : null;
  return {
    loggedIn: !!token,
    user: decoded,
    role: decoded?.aud || null,
    email: decoded?.Email || null
  };
};

const initialState = buildAuthState();

export const authSlice = createSlice({
  initialState,
  name: 'auth',
  reducers: {
    loginSuccess: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        loggedIn: true,
        user: payload
      };
    },
    setRole: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        loggedIn: true,
        role: payload || null
      };
    },
    setEmail: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        email: payload || null
      };
    },
    logout: () => ({
      loggedIn: false,
      user: null,
      role: null,
      email: null
    }),
    updateUser: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        user: {
          ...(state.user ? state.user : {}),
          ...payload
        }
      };
    }
  }
});

export const {
  logout,
  setRole,
  setEmail,
  loginSuccess,
  updateUser
} = authSlice.actions;

export default authSlice.reducer;
